/* =====================================================================
   THE ROOM ENGINE — E6: THE TWO BOOKS ON THE DESK

   E4 made the shut covers objects in the scene — buckram and morocco,
   their boards and their block, lit and shadowed by the one sun. What
   they did not have was an inside, because nothing here opened them.
   This does.

   AN OPEN BOOK IS READ, SO IT IS DOM OVER THE CANVAS. That is the whole
   rule (the Google-Maps split, and the standing ruling that text which
   is read stays DOM): the cover is a thing in the room and is drawn; the
   page is type and is set. The markup for both books is already in the
   document — it has been since before the engine — so nothing here
   builds chrome; it turns pages.

   Ported from survey-map.js (the Journal at :8316-8818, the field book
   at :8228-8307), with the four places it reached into the sheet's SVG
   replaced by the engine's own published face:

     · `markPoint(date)` -> `Room.cellOf(date)` — the day's own cell, in
       map units, from the same arithmetic the pick uses;
     · `App.canvas.centreOn` -> `Room.centreOn`;
     · `a.sv-mark.is-open` / `highlightMark()` — dead on the sheet since
       v31 B, because the SVG has been hidden from the first computed
       style (v32 A noted it and would not patch a hidden node). Here the
       mark on the ground is the engine's own: opening an essay PINS its
       day, so the thread stands from the card to the mark on the plate,
       and running the eye down the contents READS each day as the
       pointer passes it. It is the thing v32 A asked for and could not
       have;
     · the essays themselves are untouched placeholders — nothing here
       restyles a line of them.

   Switches: `?book=1` the field book open on load · `?journal=1` the
   Journal at its contents · `?journal=<YYYY-MM-DD>` at that essay.
   ===================================================================== */
(function (root) {
'use strict';

var Q = new URLSearchParams(location.search);
var B = {};
root.RoomBooks = B;

var POSTS = [];
var Book = { spread: 0, leaves: [], spreads: 1, perView: 2 };
var Journal = { post: null, mode: null, spread: 0, pages: 1, spreads: 1, perView: 2, pitch: 0 };
var essayCache = new Map();
var lastEssay = null;

function el(id) { return document.getElementById(id); }
function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
function isPortrait() { return window.innerHeight > window.innerWidth * 1.02; }
function singleLeaf() {
  /* PO1: a phone's book is one leaf whichever way the phone is held (on
     its side it lies sideways, drawn for the phone upright) */
  if (/(^|\s)phone(\s|$)/.test(document.documentElement.className)) return true;
  var portrait = window.matchMedia
    ? window.matchMedia('(orientation: portrait)').matches
    : window.innerHeight >= window.innerWidth;
  return portrait || !!(window.matchMedia && window.matchMedia('(max-width: 820px)').matches);
}
var NUM_W = ['', 'one','two','three','four','five','six','seven','eight','nine','ten',
             'eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen',
             'eighteen','nineteen','twenty','twenty-one','twenty-two','twenty-three',
             'twenty-four','twenty-five','twenty-six'];
function words(n) { return NUM_W[n] || String(n); }
function postByDate(d) { for (var i = 0; i < POSTS.length; i++) if (POSTS[i].date === d) return POSTS[i]; return null; }
function pageParam() { var m = /[?&]p=(\d+)/.exec(location.search); return m ? parseInt(m[1], 10) : 1; }
/* THE VIEW RIDES WITH THE PATH. The hash is the sheet's attitude, and a
   pushState that dropped it would land a reader back at the fit. */
function withView(url) { return url + (location.hash || ''); }

/* ==== C: THE LEAF TURNS (Tommy, 2026-09-20: "i don't love the way
   changing page in the journal works or rather how it's animated, it
   slides the contents across? could we do an actual page turn or
   something?"). The journal's pages are the columns of one flow laid east
   in a strip, and a spread was a translate of that strip; the field
   book's were swapped in place. Both turn now: the leaf that moves is a
   LEAF — a box the size of one page, hinged at the spine, that carries
   on its front what the page looked like and on its back what the page
   it lands on looks like, rotates through 180 degrees in the inner's
   perspective, and is taken away the instant it lands. Beneath it the
   real pages are already the NEW spread from the first frame (the far
   page is revealed as the leaf lifts), except that the page the leaf
   will land on keeps a `stay` — a snapshot of what it was — until the
   leaf covers it, so nothing on the desk changes but the leaf in the
   air. The state (`dealSpread`, `applyTurn`) is written exactly as it
   was, before the turn begins: the folios, the running heads, the history
   entry and the arrows are the new spread's from the first frame, and a
   turn is only ever a picture in front of a book that has already
   turned. Snapshots are clones with their ids stripped and no pointer:
   the journal's face is the leaf's own furniture plus a clone of the
   flow at that spread's offset (the same trick desk-books.js's
   leafCloneSync plays for the hinge), the field book's is the page.

   ONE LEAF AT A TIME: a second turn while one is in the air finishes the
   first at once (the book beneath is already right) and starts its own.
   The old translate (the slide) is gone: Tommy, 2026-09-20, "turn is
   great, slide is rubbish". A window showing one leaf, a reader who asked
   for reduced motion, and a book still opening or closing all get the
   swap: there is no far page to turn on to, or the leaves are already in
   motion on the hinge's own clock. Nothing here touches the panel
   (desk-books.js panelsAtPose writes its matrix every frame): the leaf
   turns INSIDE the inner, on the pages.

   450 ms on an ease that leaves firmly and lands softly; the light
   across the leaf is a gradient whose weight follows the turn (dark at
   the spine as it stands, catching the light at the free edge), and the
   page being uncovered takes the leaf's cast. `prefers-reduced-motion`
   is the swap. */
var TURN_MS = 450, TURN_EASE = 'cubic-bezier(.3, .05, .2, 1)';
function reducedMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}
function stripIds(n) {
  if (n.removeAttribute) n.removeAttribute('id');
  var d = n.querySelectorAll ? n.querySelectorAll('[id]') : [];
  for (var i = 0; i < d.length; i++) d[i].removeAttribute('id');
  return n;
}
var turning = { key: null, journal: null };
function endTurn(which) {
  var t = turning[which];
  if (!t) return;
  turning[which] = null;
  t.nodes.forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
  t.book.removeAttribute('data-turning');
}
/* may this book turn a leaf now: two leaves on show, the book landed
   (`reading`, or no desk at all), and motion allowed */
function canTurn(which, perView, opts) {
  if ((opts && opts.instant) || perView !== 2 || reducedMotion()) return false;
  var b = el(which);
  if (!b || b.getAttribute('data-open') !== 'true') return false;
  var st = b.getAttribute('data-book-motion');
  return !st || st === 'reading';
}
/* the turn. `before` and `after` are [west, east] faces — nodes that look
   exactly as the two pages did and do; dir +1 turns the east leaf over
   to the west, -1 the west leaf over to the east */
function runTurn(which, inner, dir, before, after) {
  endTurn(which);
  var book = el(which), fwd = dir > 0;
  var stay = document.createElement('div');
  stay.className = 'leaf-stay leaf-stay--' + (fwd ? 'left' : 'right');
  stay.appendChild(fwd ? before[0] : before[1]);
  var cast = document.createElement('div');
  cast.className = 'leaf-cast leaf-cast--' + (fwd ? 'right' : 'left');
  var turn = document.createElement('div');
  turn.className = 'leaf-turn leaf-turn--' + (fwd ? 'fwd' : 'back');
  var front = document.createElement('div'); front.className = 'leaf-turn-face leaf-turn-front';
  var back = document.createElement('div'); back.className = 'leaf-turn-face leaf-turn-back';
  front.appendChild(fwd ? before[1] : before[0]);
  back.appendChild(fwd ? after[0] : after[1]);
  var sf = document.createElement('span'); sf.className = 'leaf-turn-shade'; front.appendChild(sf);
  var sb = document.createElement('span'); sb.className = 'leaf-turn-shade'; back.appendChild(sb);
  turn.appendChild(front); turn.appendChild(back);
  [stay, cast, turn].forEach(function (n) { n.setAttribute('aria-hidden', 'true'); inner.appendChild(n); });
  var t = { book: book, nodes: [stay, cast, turn] };
  turning[which] = t;
  if (!turn.animate) { endTurn(which); return; }        /* no Web Animations: the swap */
  book.setAttribute('data-turning', fwd ? 'fwd' : 'back');
  var opt = { duration: TURN_MS, easing: TURN_EASE, fill: 'forwards' };
  var a = turn.animate([{ transform: 'rotateY(0deg)' }, { transform: 'rotateY(' + (fwd ? -180 : 180) + 'deg)' }], opt);
  sf.animate([{ opacity: 0 }, { opacity: .8, offset: .5 }, { opacity: .8 }], opt);
  sb.animate([{ opacity: .8 }, { opacity: .8, offset: .5 }, { opacity: 0 }], opt);
  cast.animate([{ opacity: 0 }, { opacity: 1, offset: .45 }, { opacity: 0 }], opt);
  a.onfinish = a.oncancel = function () { if (turning[which] === t) endTurn(which); };
}
/* a field-book page as it stands: the ref, the folio and the corner */
function keyFace(page) {
  var w = document.createElement('div');
  w.className = 'leaf-face leaf-face--' + (page.classList.contains('book-page--left') ? 'left' : 'right');
  w.appendChild(stripIds(page.cloneNode(true)));
  return w;
}
/* a journal page at a given spread: the leaf's furniture, and the flow
   cloned at that spread's offset, cut to the leaf */
function journalFace(side, spread) {
  var inner = el('journal-inner'), leaf = inner && inner.querySelector('.journal-leaf--' + side);
  var w = document.createElement('div');
  w.className = 'leaf-face leaf-face--' + side;
  if (leaf) {
    var lc = stripIds(leaf.cloneNode(true));
    if (spread === 0) [].slice.call(lc.querySelectorAll('.journal-head-no, .journal-head-title'))
      .forEach(function (n) { n.style.visibility = 'hidden'; });
    w.appendChild(lc);
  }
  var flow = el('journal-flow');
  if (flow) {
    var clip = document.createElement('div');
    clip.className = 'leaf-flow-clip leaf-flow-clip--' + side;
    var fc = stripIds(flow.cloneNode(true));
    fc.style.transition = 'none';
    fc.style.transform = 'translateX(' + (-spread * Journal.perView * Journal.pitch) + 'px)';
    clip.appendChild(fc);
    w.appendChild(clip);
  }
  return w;
}

/* which book is out on the desk */
function openBook() {
  var j = el('journal');
  if (j && j.getAttribute('data-open') === 'true') return 'journal';
  var k = el('key');
  if (k && k.getAttribute('data-open') === 'true') return 'key';
  return null;
}

/* ==== BK1: THE MAP VIEW, AND WHAT MAY OPEN A BOOK ====================
   Tommy, after 62541ce: "when the map is folded away, the field guide and
   journal should always be enclosed, and you shouldn't be able to click on
   them outside of the map view."

   Every way a book can be opened asks this first — the two covers, `b`,
   `j`, the contents, the marks on the plate, `RoomBooks.showContents` and
   `RoomBooks.openByDate` — and a refusal is a refusal: false, no
   animation, nothing written to the DOM. Shutting a book is never gated:
   a book can always be put away, and folding the map does exactly that
   (desk-books.js watches the fold's own state and calls closeOne).

   WHY THIS IS NOT `Room.mapLive()`, which is the engine's own gate. That
   one is about the HAND — the wheel, the drag, the pick — and it also
   counts a held discovery card as not live, because the hand is on the
   card. A card standing on the map is still the map view, and the card's
   own numeral opens the journal (day.js), so that clause is not this
   test. What is left is the three states Tommy names, each read from the
   engine's own published state. With no engine at all — a page whose
   script has not landed — the DOM books are the whole of what there is,
   and they open. */
/* ==== PO1 (2026-10-02): ON THE PHONE, PORTRAIT IS THE JOURNAL ========
   notes/phone-design.md. Tommy: "if you just have the journal when you land
   on portrait, then that's a version of the site that's fine to use ...
   There's no reason in portrait mode you'd want to be able to get to the
   map." So upright a book is never shut to nothing: shutting an essay
   gives the contents, the contents do not shut, and shutting the Field
   Book gives the Journal back where it was left (RS1). On its side the
   phone is the map, and a book opened there lies sideways for the turn
   (phone.js); it opens as anywhere else. Which way the phone is held is
   phone.js's to say (RoomPhone.land: the screen's own orientation, not
   the window's shape). */
var PHONE = /(^|\s)phone(\s|$)/.test((typeof document !== "undefined" && document.documentElement ? document.documentElement.className : ""));
function upright() {
  if (!PHONE) return false;
  var P = root.RoomPhone;
  return P && P.land ? !P.land() : window.innerHeight >= window.innerWidth;
}
function mapView() {
  var R = root.Room;
  if (!R) return true;
  /* EG4: a phone held upright IS the Journal (PO1): its page is the glass
     and not a book on the desk, so it opens whatever the desk is doing
     (the reader standing in the room, the sheet folded) */
  if (upright()) return true;
  if (R.inRoom && R.inRoom()) return false;        /* standing in the room */
  if (R.lapUp && R.lapUp()) return false;          /* turned to the machine */
  if (R.folded && R.folded() > 0.0005) return false;   /* the sheet is folded away */
  var O = root.RoomObjects;
  if (O && O.foldGrab) return false;               /* a hand is folding it now */
  return true;
}
/* THE ONE PATH THAT DOES NOT REFUSE. A deep link is not a click on a
   cover: the reader asked for an essay by its own URL and has to land
   somewhere it can be read. So `{land: true}` opens the book and brings
   the view back to the paper — the sheet flat, the machine left, the
   reader seated. It acts once. */
function landInMapView() {
  var R = root.Room; if (!R) return;
  if (R.folded && R.folded() > 0.0005 && R.unfold) R.unfold();
  if (R.lapUp && R.lapUp() && R.terminal) R.terminal(false);
  if (R.inRoom && R.inRoom() && R.room) R.room(false);
}
/* IS A LANDING IN FLIGHT. A landing is on its way to a flat sheet and a
   seated reader, so a fold it passes through on the way is not the reader
   putting the map away, and desk-books.js's fold watch (which shuts the
   books) stands off until it has landed. DL1 (2026-09-23): the hash no
   longer carries a room or a fold token, so the landing no longer waits
   up to 8 s for one to fire: it opens the book and is done. */
var landing = false;
function land() {
  if (landing) return; landing = true;
  var t0 = Date.now();
  (function w() {
    if (!root.Room || !root.__ready) {
      if (Date.now() - t0 > 12000) { landing = false; return; }
      setTimeout(w, 120); return;
    }
    if (!openBook()) { landing = false; return; }
    if (!mapView()) { landInMapView(); landing = false; return; }
    landing = false;
  })();
}

/* ---- the field book ------------------------------------------------ */
function setKey(open, opts) {
  var k = el('key'), tab = el('key-tab');
  if (!k) return false;
  /* BK1: not outside the map view — unless this is the deep link, which
     lands instead of refusing. */
  if (open) {
    if (opts && opts.land) land();
    else if (!mapView()) return false;
  }
  /* ONE OPEN BOOK. A surveyor reading the journal is not also reading
     the field book, so opening either shuts the other. */
  if (open) closeJournal({ really: true });
  if (open && Book.leaves.length) repageBook(Book.spread * Book.perView);
  if (!open) endTurn('key');
  var was = k.getAttribute('data-open') === 'true';
  k.setAttribute('data-open', open ? 'true' : 'false');
  if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
  /* PO1: upright, the Field Book put down gives the Journal back — once
     the press that put it down is over, or the Journal's own listener
     takes that same press as a tap off its leaf and turns it back to the
     contents */
  if (!open && was && upright()) setTimeout(resumeJournal, 0);
  return true;
}

/* ==== R42 (b): THE LAND'S TINT SCALE, OFF THE ENGINE'S OWN LADDER =====
   The field book explained the contours, the levels, the coast, the water
   and every mark on the plate, and said nothing at all about the HYPSOMETRIC
   TINTS — the pale low ground, the ochre, the browns, the scree and the
   snow — which are what colours nine tenths of the sheet.

   It is set the way an atlas sets a layer-tint scale: the bands in the
   order of height, and under each one the figure it starts at. Neither the
   colours nor the figures are typed into the key: they are read here from
   field.js's ladder (`C.TINT_COL` and `C.TINT_AT`, ROOM-PLAN §6, grown by
   R26 to eleven rungs), which is the same array the ground fragment is
   generated from. So the key cannot go stale against the plate.

   The ladder's rule: tintBand returns 1 under the first rung and i+2 at
   A[i], so the strip is TINT_COL[1..n-1], the first cell being the ground
   below the first rung and having no figure to print. TINT_COL[0] is the
   base wash the plate lays under all of them and is not a band.

   Written before the leaves are dealt, because showSpread CLONES the leaf
   it shows: a row filled afterwards would be filled on a node nobody sees.
   ==================================================================== */
/* ==== R70: AND THE FIGURES ARE THE RECORD'S OWN COMMITS.
   The ladder does not move — the bands, the tones and the heights they
   stand at are the sheet's — but on a stranger's sheet the rung that is
   printed `22` is reached by a different number of THAT person's
   commits, and printing 22 there would be the key telling a lie about
   the ground beside it. So each figure comes back through the ladder's
   `from()`. A figure under ten is set to one decimal: on a quiet record
   the first three rungs land inside a couple of commits of each other
   and whole numbers would print the same figure twice. */
function tintFig(v, lad) {
  if (lad.id) return String(v);
  var r = lad.from(v);
  return r >= 10 ? String(Math.round(r)) : (Math.round(r * 10) / 10).toFixed(1);
}
/* R70: the SOURCE leaf and not whatever clone is on show. `book-ref-left`
   stands before `book-ref-source` in the document, so once a spread has
   been dealt getElementById answers with the clone — painting that leaves
   the source stale and the figures come back wrong on the next page turn.
   Everything here writes the source; `B.rescale` re-deals. */
function srcEl(id) {
  var src = el('book-ref-source');
  return (src && src.querySelector('#' + id)) || el(id);
}
function paintTintScale(scale) {
  var bar = srcEl('lg-tints'), figs = srcEl('lg-tint-figs');
  var C = window.RoomField && RoomField.C;
  if (!bar || !figs || !C || !C.TINT_COL || !C.TINT_AT) return;
  var lad = RoomField.ladder(scale === undefined ? (window.Room && Room.sheetScale && Room.sheetScale()) : scale);
  var col = C.TINT_COL, at = C.TINT_AT, n = col.length - 1, h = '', f = '';
  for (var i = 1; i <= n; i++) {
    h += '<span style="background:' + col[i] + '"></span>';
    /* band i starts at at[i-2]; band 1 is the ground under the first rung */
    f += '<span>' + (i > 1 ? tintFig(at[i - 2], lad) : '') + '</span>';
  }
  bar.innerHTML = h;
  figs.innerHTML = f;
}

/* ==== R70: THE LEVELS LEAF, RE-STRUCK FOR THE RECORD ON THE SHEET.
   The leaf says sea level is five commits and "does not move, so every
   year may be compared against every other" — true of his own sheet and
   of every year of it, and no longer true of a stranger's, where five
   SHEET commits fall at the record's own quieter number. The figure and
   the sentence after it are the two things that change; both are
   PLACEHOLDER WORDING for Tommy to write. */
var SEA_WORD = ['nought', 'one', 'two', 'three', 'four', 'five', 'six', 'seven',
                'eight', 'nine', 'ten'];
function seaFigure(n) {
  if (n >= 10) return String(Math.round(n));
  var r = Math.round(n * 10) / 10;
  return r === Math.round(r) ? SEA_WORD[Math.round(r)] : r.toFixed(1);
}
/* a DOM write that writes the same string is still a DOM write, and the
   boot one lands between the font's arrival and the furniture's raster:
   measured, it moved 72 antialiased pixels of the cartouche's rule by up
   to 5/255 at realDpr 1.25 (R70, the 1.25 fit pair). So nothing is
   written unless it has changed, and his own page does not write at all. */
function setText(el, v) { if (el.textContent !== v) el.textContent = v; }
function paintLevels(scale) {
  var fig = srcEl('key-sea'), note = srcEl('key-scale-note');
  if (!fig || !note) return;
  if (!scale) {                                  /* his own record */
    setText(fig, 'five');
    setText(note, '');
    return;
  }
  /* the three answers the levels leaf has to give when the sheet is
     somebody else's: `books.levels_few`, `books.levels_none` and
     `books.levels_own` (with `books.levels_capped` written into it). */
  if (scale.floored) {
    setText(fig, 'five');
    note.textContent = scale.n
      ? RoomCopy.t('books.levels_few', { n: scale.n })
      : RoomCopy.t('books.levels_none');
    return;
  }
  setText(fig, seaFigure(scale.sea));
  note.textContent = RoomCopy.t('books.levels_own', {
    p: scale.p,
    capped: scale.capped ? RoomCopy.t('books.levels_capped') : ''
  });
}

/* ==== THE LEAVES ARE DEALT BY MEASURE. Tommy, 2026-09-20: "the current
   field guide's text goes off the bottom of the book with no scroll, if
   it stays that long it should be an extra page?" The old source was cut
   into leaves by hand to one window's measure, and a smaller window cut
   the second leaf off at the foot (measured at 1537x865: 559 px of
   writing on a 457 px page; the surveyor's own links were below the
   fold). The source is ONE RUN OF SECTIONS now (base.njk), and this deals
   it: each heading, each legend row and each paragraph is a UNIT, and the
   units are laid on to the left page — the real one, at the real width,
   inside the real ruling — one at a time, the page's own height read
   back after each, so a leaf holds exactly what fits it at this window
   and the rest goes on to the next. A heading travels with the unit
   after it (it is never the last line of a leaf); a list continued on
   the next leaf is a new list in a new section with no heading and no
   rule over it, which is how a printed key continues. Nothing is painted
   between the measuring and the dealing, so a reader never sees the
   measuring page. Run again on resize, when the fonts land (a fallback
   face wraps differently) and when a stranger's record re-strikes the
   levels line. A unit holds its SOURCE node and is cloned at show time,
   so R70's repaints of the source are what the next spread shows. */
function keyUnits() {
  var src = el('book-ref-source'), units = [];
  if (!src) return units;
  [].slice.call(src.querySelectorAll('.key-sec')).forEach(function (sec) {
    [].slice.call(sec.children).forEach(function (ch) {
      if (ch.classList.contains('key-legend')) {
        [].slice.call(ch.children).forEach(function (li) { units.push({ sec: sec, list: ch, node: li }); });
      } else units.push({ sec: sec, list: null, node: ch,
                          /* FB2: a group's name and the colophon's ornament go
                             with what follows them, as a heading does */
                          head: ch.classList.contains('key-head') || ch.classList.contains('key-sub') ||
                                ch.classList.contains('key-orn') });
    });
  });
  return units;
}
function newState() { return { sec: null, secEl: null, list: null, listEl: null }; }
/* lay one unit into a page's ref, opening a section or a list as the unit
   needs; `st` is the ref's running state */
function layUnit(ref, st, u) {
  if (st.sec !== u.sec) {
    st.secEl = document.createElement('section');
    st.secEl.className = u.sec.className;
    ref.appendChild(st.secEl);
    st.sec = u.sec; st.list = null; st.listEl = null;
  }
  var host = st.secEl;
  if (u.list) {
    if (st.list !== u.list) {
      st.listEl = document.createElement('ul');
      st.listEl.className = u.list.className;
      st.secEl.appendChild(st.listEl);
      st.list = u.list;
    }
    host = st.listEl;
  } else st.list = null;
  var n = u.node.cloneNode(true);
  host.appendChild(n);
  return n;
}
/* the writing's own room on a leaf: the inner's height (aspect-ratio's,
   or the one desk-books.js writes in motion, the same number) less the
   page's padding, in which the folio sits */
function leafUsable() {
  var k = el('key'), inner = k && k.querySelector('.book-inner');
  var ref = el('book-ref-left'), page = ref && ref.closest('.book-page');
  if (!inner || !page) return 0;
  var cs = getComputedStyle(page);
  return inner.clientHeight - (parseFloat(cs.paddingTop) || 0) - (parseFloat(cs.paddingBottom) || 0);
}
function dealLeaves() {
  var ref = el('book-ref-left'), units = keyUnits();
  if (!ref || !units.length) { Book.leaves = []; return; }
  var usable = leafUsable();
  if (!(usable > 36)) { Book.leaves = [units]; return; }   /* no page laid out (no-js, nogl): one leaf */
  var leaves = [], cur = [], st = newState();
  ref.innerHTML = '';
  leaves.push(cur);
  function fits() { return ref.offsetHeight <= usable + 0.5; }
  for (var i = 0; i < units.length; i++) {
    var u = units[i], group = [u];
    if (u.head && i + 1 < units.length) group.push(units[++i]);
    /* FB2: NO WIDOWS. A list's last sign never stands alone at the top of
       a leaf: the one before it goes with it. */
    else if (u.list && units[i + 1] && units[i + 1].list === u.list &&
             !(units[i + 2] && units[i + 2].list === u.list)) group.push(units[++i]);
    var laid = group.map(function (g) { return layUnit(ref, st, g); });
    if (!fits() && cur.length) {
      /* take the group off, with any shell it opened and left empty, and
         open the next leaf with it. A unit that will not fit an EMPTY
         leaf stays where it is: the page is the limit, not a loop. */
      laid.forEach(function (n) {
        var p = n.parentNode; p.removeChild(n);
        while (p && p !== ref && !p.childNodes.length) { var q = p.parentNode; q.removeChild(p); p = q; }
      });
      ref.innerHTML = ''; st = newState(); cur = []; leaves.push(cur);
      group.forEach(function (g) { layUnit(ref, st, g); });
    }
    group.forEach(function (g) { cur.push(g); });
    /* FB2: a section marked `key-sec--leaf` (the title leaf) has its leaf
       to itself: the next section starts on a fresh one. FP1 (2026-10-06):
       but only where it faces that leaf. One leaf at a time (a phone, a
       tablet) showed the title over an empty page, which read as broken
       on an iPad; there the writing starts under the title. */
    var nx = units[i + 1];
    if (nx && nx.sec !== u.sec && u.sec.classList.contains('key-sec--leaf') && Book.perView > 1) {
      ref.innerHTML = ''; st = newState(); cur = []; leaves.push(cur);
    }
  }
  ref.innerHTML = '';
  Book.leaves = leaves;
}

function paginateBook() {
  paintTintScale();
  paintLevels(window.Room && Room.sheetScale ? Room.sheetScale() : null);
  repageBook(0);
}

function repageBook(page) {
  Book.mkey = bookKey();
  Book.perView = singleLeaf() ? 1 : 2;
  dealLeaves();
  Book.spreads = Math.max(1, Math.ceil(Book.leaves.length / Book.perView));
  showSpread(Math.floor((page || 0) / Book.perView), { instant: true });
}

/* the spread's two pages, written: what showSpread shows, with or
   without a turn in front of it */
function dealSpread(n) {
  Book.spread = clamp(n, 0, Book.spreads - 1);
  ['left', 'right'].forEach(function (side, i) {
    var ref = el('book-ref-' + side), folio = el('folio-' + side);
    var page = Book.spread * Book.perView + i;
    var leaf = i < Book.perView ? Book.leaves[page] : null;
    if (!ref) return;
    ref.innerHTML = '';
    if (leaf) {
      var st = newState();
      leaf.forEach(function (u) { layUnit(ref, st, u); });
      if (folio) folio.textContent = RoomCopy.t('journal.folio', { n: page + 1, of: Book.leaves.length });
    } else if (folio) folio.textContent = '';
  });
  if (el('book-prev')) el('book-prev').hidden = Book.spread === 0;
  if (el('book-next')) el('book-next').hidden = Book.spread >= Book.spreads - 1;
}

function showSpread(n, opts) {
  var target = clamp(n, 0, Book.spreads - 1);
  var dir = target > Book.spread ? 1 : target < Book.spread ? -1 : 0;
  if (!dir || !canTurn('key', Book.perView, opts)) { endTurn('key'); dealSpread(target); return; }
  var pages = ['left', 'right'].map(function (side) { return el('book-ref-' + side).closest('.book-page'); });
  if (!pages[0] || !pages[1]) { dealSpread(target); return; }
  var before = pages.map(keyFace);
  dealSpread(target);
  var after = pages.map(keyFace);
  runTurn('key', el('key').querySelector('.book-inner'), dir, before, after);
}

function wireKey() {
  var k = el('key');
  if (!k) return;
  if (Q.get('book') === '1') setKey(true, { land: true });
  var tab = el('key-tab');
  if (tab) tab.addEventListener('click', function () { setKey(k.getAttribute('data-open') !== 'true'); });
  /* Three ways to shut a book on a desk: the cover again, a hand put down
     anywhere else, or — R72 (2026-09-21) — a hand put down on the book's
     own BOARD, the cloth round the leaves, which is the cover being closed.
     Esc is the fourth. The turned-down notch at the top right is gone: it
     was a window's close button in costume, in a window's place. */
  document.addEventListener('pointerdown', function (e) {
    if (k.getAttribute('data-open') !== 'true') return;
    if (isStowed(k)) return;                 /* ST1: put away by a turn, not out */
    if (e.target.closest && e.target.closest('#key')) {
      if (e.target.closest('#key-body') && !e.target.closest('.book-inner, button, a')) setKey(false);
      return;
    }
    setKey(false);
  }, true);
  paginateBook();
  /* the deal was measured in whatever face the page had; the book's own
     face wraps a line differently, so it is dealt again when it lands */
  if (document.fonts && document.fonts.ready)
    document.fonts.ready.then(function () { repageBook(Book.spread * Book.perView); });
  if (el('book-next')) el('book-next').addEventListener('click', function () { showSpread(Book.spread + 1); });
  if (el('book-prev')) el('book-prev').addEventListener('click', function () { showSpread(Book.spread - 1); });
  /* C: and the key is taken HERE. It used to bubble on to wireKeys, which
     turned the same page again — harmless for a swap to the same spread,
     but a second call to the same spread is now "no turn", which took
     the leaf out of the air on the frame it left. */
  k.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { showSpread(Book.spread + 1); e.preventDefault(); e.stopPropagation(); }
    else if (e.key === 'ArrowLeft') { showSpread(Book.spread - 1); e.preventDefault(); e.stopPropagation(); }
  });
}

/* ---- the journal ---------------------------------------------------- */
function markBookRow(date) {
  document.querySelectorAll('.journal-contents .jc-entry').forEach(function (r) {
    r.classList.toggle('is-open', r.getAttribute('data-date') === date);
  });
}

/* THE CONTENTS KNOW THE PLATE. Running the eye down the list reads each
   day on the ground — the pencil cross walks the list with the pointer —
   which is what v32 A wanted `highlightMark` to do and could not, because
   there was nothing on the glass to mark. */
function wireContentsRows() {
  document.querySelectorAll('.journal-contents .jc-entry').forEach(function (a) {
    var date = a.getAttribute('data-date');
    /* X2: THE BOOKS DO NOT REACH THE MAP FROM THE ROOM. A line in the
       journal's contents marks the day on the ground (it no longer flies
       the sheet to it, JF1); standing up, or with the sheet folded, neither happens —
       the essay still opens, because opening a book is a thing you do IN
       the room and not to the map. */
    function live() { return !(root.Room && Room.mapLive) || Room.mapLive(); }
    /* PH10: not on the phone. A finger has no hover, and on iOS a line that
       changes the page on pointerenter is answered with a hover and no
       click ("I couldn't click into any of the actual articles"); and the
       phone's card is not lying under an open book to be shown. */
    function show(on) { if (!PHONE && live() && root.Room && Room.dayShow) Room.dayShow(on ? date : null); }
    a.addEventListener('pointerenter', function () { show(true); });
    a.addEventListener('pointerleave', function () { show(false); });
    a.addEventListener('focus', function () { show(true); });
    a.addEventListener('blur', function () { show(false); });
    a.addEventListener('click', function (e) {
      e.preventDefault();
      show(false);
      /* JF1 (2026-10-10): FROM THE CONTENTS THE MAP STAYS PUT. It used to fly
         the sheet to the essay's mark; Tommy: "i don't want the map to
         'move' when i open a journal entry from the journal". The book
         opens and the ground is left where the reader had it. */
      openByDate(date, { fly: false });
    });
  });
}

/* A CODE BLOCK IS NOT A CODE BLOCK IN A BOOK. It is a slip of typewritten
   paper someone pasted in, and a photograph is a photograph with corners
   on it. Both are done on the way into the flow, so the essay's own
   markup stays ordinary HTML for anyone reading it without this page. */
function dressEssay(rootEl) {
  [].slice.call(rootEl.querySelectorAll('pre')).forEach(function (pre) {
    var fig = document.createElement('figure');
    fig.className = 'journal-slip';
    var tape = document.createElement('span');
    tape.className = 'journal-tape';
    tape.setAttribute('aria-hidden', 'true');
    pre.parentNode.insertBefore(fig, pre);
    fig.appendChild(tape); fig.appendChild(pre);
  });
  [].slice.call(rootEl.querySelectorAll('img')).forEach(function (img) {
    var host = img.closest('figure');
    var cap = host ? host.querySelector('figcaption') : null;
    var holder = host;
    if (!holder) {
      var par = img.parentNode;
      if (par && par.tagName === 'P' && par.textContent.trim() === '') {
        holder = document.createElement('figure');
        par.parentNode.insertBefore(holder, par);
        holder.appendChild(img);
        par.parentNode.removeChild(par);
      } else {
        holder = document.createElement('figure');
        img.parentNode.insertBefore(holder, img);
        holder.appendChild(img);
      }
    }
    holder.className = 'journal-photo';
    var plate = document.createElement('span');
    plate.className = 'journal-plate';
    img.parentNode.insertBefore(plate, img);
    plate.appendChild(img);
    ['tl', 'tr', 'br', 'bl'].forEach(function (c) {
      var s2 = document.createElement('span');
      s2.className = 'journal-corner journal-corner--' + c;
      s2.setAttribute('aria-hidden', 'true');
      plate.appendChild(s2);
    });
    if (img.alt && !cap) {
      cap = document.createElement('figcaption');
      cap.textContent = img.alt;
      holder.appendChild(cap);
    }
  });
}

var BM_GLYPH = '<svg viewBox="0 0 30 12" aria-hidden="true">' +
  '<path d="M12.4 1.5V9M7 9L12.4 3.6 17.8 9M6 9h12.8" class="lg-bm"/></svg>';

function buildContents() {
  var flow = el('journal-flow');
  flow.style.transform = 'none';
  flow.innerHTML = '';
  var posts = POSTS.slice().sort(function (a, b) { return b.no - a.no; });
  var op = document.createElement('header');
  op.className = 'journal-opening journal-opening--contents';
  var ref = document.createElement('p');
  ref.className = 'journal-opening-ref';
  ref.innerHTML = BM_GLYPH + '<span></span>';
  ref.querySelector('span').textContent = RoomCopy.t('journal.name');
  var h1 = document.createElement('h1');
  h1.className = 'journal-opening-title';
  h1.textContent = RoomCopy.t('journal.contents');
  var dt = document.createElement('p');
  dt.className = 'journal-opening-date';
  var first = posts[posts.length - 1], last = posts[0];
  dt.textContent = posts.length
    ? RoomCopy.t('journal.span', { n: words(posts.length),
                                   from: (first.readable || '').replace(/^\d+ /, ''),
                                   to: (last.readable || '').replace(/^\d+ /, '') })
    : RoomCopy.t('journal.empty');
  op.appendChild(ref); op.appendChild(h1); op.appendChild(dt);
  flow.appendChild(op);

  var ol = document.createElement('ol');
  ol.className = 'journal-contents';
  posts.forEach(function (p) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.className = 'jc-entry';
    a.setAttribute('href', p.url);
    a.setAttribute('data-date', p.date);
    var no = document.createElement('span'); no.className = 'jc-no'; no.textContent = p.numeral || '';
    var ti = document.createElement('span'); ti.className = 'jc-title'; ti.textContent = p.title || '';
    var dd = document.createElement('span'); dd.className = 'jc-date'; dd.textContent = p.readable || '';
    a.appendChild(no); a.appendChild(ti); a.appendChild(dd);
    if (p.excerpt) {
      var ex = document.createElement('span'); ex.className = 'jc-ex'; ex.textContent = p.excerpt;
      a.appendChild(ex);
    }
    li.appendChild(a); ol.appendChild(li);
  });
  flow.appendChild(ol);
  var endm = document.createElement('span');
  endm.className = 'journal-end'; endm.textContent = ' ';
  flow.appendChild(endm);
}

function buildFlow(post, bodyHTML) {
  var flow = el('journal-flow');
  flow.style.transform = 'none';
  flow.innerHTML = '';
  var op = document.createElement('header');
  op.className = 'journal-opening';
  var ref = document.createElement('p');
  ref.className = 'journal-opening-ref';
  ref.innerHTML = BM_GLYPH + '<span></span>';
  ref.querySelector('span').textContent = 'Mark ' + (post.numeral || '');
  /* NF1: a leaf with no mark (the 404's) carries no reference line */
  if (!post.numeral) ref.hidden = true;
  var h1 = document.createElement('h1');
  h1.className = 'journal-opening-title';
  h1.textContent = post.title || '';
  var dt = document.createElement('p');
  dt.className = 'journal-opening-date';
  dt.textContent = (post.readable || '') + (post.words ? ' · ' + post.words + ' words' : '');
  op.appendChild(ref); op.appendChild(h1); op.appendChild(dt);
  flow.appendChild(op);
  var tmp = document.createElement('div');
  tmp.innerHTML = bodyHTML;
  dressEssay(tmp);
  while (tmp.firstChild) flow.appendChild(tmp.firstChild);
  var endm = document.createElement('span');
  endm.className = 'journal-end'; endm.textContent = ' ';
  flow.appendChild(endm);
}

/* HOW MANY LEAVES IS THIS. The flow is a fixed-height multicolumn box, so
   the pages it has no room for run off to the east; the last mark in the
   text says how far east it got, and that is the page count. */
/* ==== PH7 (2026-10-02): A PHOTOGRAPH TAKES THE REST OF THE PAGE IT
   FOLLOWS. On the phone's one narrow leaf a pasted-in photograph (which
   may not break) that did not fit under the paragraph before it went to
   the next page whole, and left the rest of the page blank: "It Wasn't a
   Slack Bot" had half of page 1 empty under "Boris Cherny's post:"
   (mobile.md shot 04). So a photograph that a page break has pushed to
   the head of a page, with a fair space left at the foot of the page
   before, is set just short enough to stay there. Not shrunk to a stamp:
   it keeps at least 110 px and 45 % of its own height, or it goes over as
   before. Phone only; the desk's spread is as it was. ==== */
function fitPhotos(flow) {
  var photos = flow.querySelectorAll('.journal-photo');
  if (!photos.length) return;
  var fr = flow.getBoundingClientRect(), colH = flow.clientHeight;
  for (var i = 0; i < photos.length; i++) {
    var ph = photos[i], img = ph.querySelector('img');
    if (!img) continue;
    img.style.maxHeight = ''; ph.style.breakInside = '';
    /* the essay's images carry no size, so one still loading measures 0
       high: the leaves are counted again when it lands */
    if (!img.complete && !img.__phWait) {
      img.__phWait = 1;
      img.addEventListener('load', function () {
        if (!Journal.post) return;
        measureJournal(); applyTurn(Journal.spread, { noHistory: true });
      }, { once: true });
    }
    var prev = ph.previousElementSibling;
    if (!prev) continue;
    var r = ph.getBoundingClientRect(), pr = prev.getClientRects();
    if (!pr.length) continue;
    var pl = pr[pr.length - 1];
    var colOf = function (x) { return Math.round((x - fr.left) / Journal.pitch); };
    if (colOf(r.left) !== colOf(pl.left) + 1) continue;      /* not pushed over */
    var cs = getComputedStyle(ph);
    var need = r.height + (parseFloat(cs.marginTop) || 0) + (parseFloat(cs.marginBottom) || 0);
    var space = colH - (pl.bottom - fr.top);
    if (space < 140 || need <= space) continue;
    var ih = img.getBoundingClientRect().height, want = ih - (need - space) - 6;
    if (want >= 110 && want >= ih * 0.45) { img.style.maxHeight = Math.floor(want) + 'px'; continue; }
    /* and when the picture itself fits but its caption does not, the
       picture stays with the words that lead to it and the caption runs
       on over the page, as a long caption does in a printed book */
    var plate = ph.firstElementChild;
    if (plate && plate.getBoundingClientRect().height + (parseFloat(cs.marginTop) || 0) + 24 <= space)
      ph.style.breakInside = 'auto';
  }
}

/* TR1: the size a book was last dealt at. On the phone a window resize
   that leaves the leaf the size it was (a turn upright, the sideways
   book having been laid at the upright leaf's size: phone.js) deals
   nothing again, so the page turned does not visibly re-set */
function bookKey() { var b = document.querySelector('#key .book-body'); return b ? b.clientWidth + 'x' + b.clientHeight : ''; }
function journalKey() { var c = el('journal-clip'); return c ? c.clientWidth + 'x' + c.clientHeight : ''; }
var PHONE_TR = /(^|\s)phone(\s|$)/.test(document.documentElement.className);
function measureJournal() {
  var flow = el('journal-flow'), clip = el('journal-clip');
  if (!flow || !clip) return;
  Journal.mkey = journalKey();
  flow.style.transform = 'none';
  var cs = getComputedStyle(flow);
  var gap = parseFloat(cs.columnGap) || 0;
  var per = singleLeaf() ? 1 : 2;
  var colW = (clip.clientWidth - gap * (per - 1)) / per;
  Journal.perView = per;
  Journal.pitch = colW + gap;
  if (per === 1 && /\bphone\b/.test(document.documentElement.className)) fitPhotos(flow);
  var endm = flow.querySelector('.journal-end');
  var dx = 0;
  if (endm && Journal.pitch > 1) dx = endm.getBoundingClientRect().left - flow.getBoundingClientRect().left;
  Journal.pages = Math.max(1, Math.round(dx / Journal.pitch) + 1);
  Journal.spreads = Math.max(1, Math.ceil(Journal.pages / per));
}

function turnTo(n, opts) {
  opts = opts || {};
  var target = clamp(n, 0, Journal.spreads - 1);
  var dir = target > Journal.spread ? 1 : target < Journal.spread ? -1 : 0;
  if (!dir || !canTurn('journal', Journal.perView, opts)) { endTurn('journal'); applyTurn(target, opts); return; }
  var was = Journal.spread;
  var before = [journalFace('left', was), journalFace('right', was)];
  applyTurn(target, opts);
  var after = [journalFace('left', target), journalFace('right', target)];
  runTurn('journal', el('journal-inner'), dir, before, after);
}
/* the spread, written: the strip's offset, the folios, the running
   heads, the arrows and the history entry */
function applyTurn(n, opts) {
  opts = opts || {};
  Journal.spread = clamp(n, 0, Journal.spreads - 1);
  var flow = el('journal-flow'), inner = el('journal-inner');
  if (!flow) return;
  flow.style.transform = 'translateX(' + (-Journal.spread * Journal.perView * Journal.pitch) + 'px)';
  if (inner) inner.setAttribute('data-spread', String(Journal.spread));
  var first = Journal.spread * Journal.perView + 1;
  var fl = el('journal-folio-left'), fr = el('journal-folio-right');
  if (Journal.perView === 1) {
    if (fl) fl.textContent = RoomCopy.t('journal.folio', { n: first, of: Journal.pages });
    if (fr) fr.textContent = '';
  } else {
    if (fl) fl.textContent = first <= Journal.pages ? String(first) : '';
    if (fr) fr.textContent = (first + 1) <= Journal.pages ? (first + 1) + ' of ' + Journal.pages : '';
  }
  var rh = el('journal-running-date');
  if (rh) rh.style.visibility = (Journal.perView === 2 && (first + 1) > Journal.pages) ? 'hidden' : '';
  var prev = el('journal-prev'), next = el('journal-next');
  var mp = el('journal-margin-prev'), mn = el('journal-margin-next');
  var atStart = Journal.spread === 0, atEnd = Journal.spread >= Journal.spreads - 1;
  if (prev) prev.hidden = atStart;
  if (next) next.hidden = atEnd;
  if (mp) mp.hidden = atStart;
  if (mn) mn.hidden = atEnd;
  if (!opts.noHistory && Journal.post && Journal.mode === 'essay') {
    history.replaceState({ sv: Journal.post.url }, '',
      withView(Journal.post.url + (first > 1 ? '?p=' + first : '')));
  }
}

function raiseJournal() {
  var book = el('journal');
  setKeyQuiet(false);
  book.setAttribute('data-open', 'true');
  var tab = el('journal-tab');
  if (tab) tab.setAttribute('aria-expanded', 'true');
}
function setKeyQuiet(open) {
  var k = el('key');
  if (!k) return;
  k.setAttribute('data-open', open ? 'true' : 'false');
  var tab = el('key-tab');
  if (tab) tab.setAttribute('aria-expanded', open ? 'true' : 'false');
}

function showContents(opts) {
  opts = opts || {};
  var book = el('journal');
  if (!book) return false;
  /* BK1: the gate, before anything is written or measured */
  if (opts.land) land();
  else if (!mapView()) return false;
  raiseJournal();
  Journal.mode = 'contents'; Journal.post = null;
  var inner = el('journal-inner');
  if (inner) inner.setAttribute('data-mode', 'contents');
  if (el('journal-no')) el('journal-no').textContent = '';
  if (el('journal-running-title')) el('journal-running-title').textContent = '';
  if (el('journal-running-date')) el('journal-running-date').textContent = RoomCopy.t('journal.name');
  buildContents();
  measureJournal();
  turnTo(opts.page ? Math.ceil(opts.page / Journal.perView) - 1 : 0, { noHistory: true, instant: true });   /* RS1 */
  wireContentsRows();
  markBookRow(lastEssay ? lastEssay.date : null);
  if (!opts.noHistory && location.pathname !== '/') history.pushState({ sv: null }, '', withView('/'));
  if (opts.focus !== false && el('journal-body')) el('journal-body').focus({ preventScroll: true });
  return true;
}

/* ST1: phone.js stows the book an upright reading had out when the phone
   is turned on to its side: open, at its page, not drawn. A hand on the
   map does not shut it; anything that opens a book brings it out first */
function isStowed(b) { var P = root.RoomPhone; return !!(P && P.stowed && P.stowed() === b); }
function unstow() { var P = root.RoomPhone; if (P && P.unstow) P.unstow(); }
function showJournal(post, bodyHTML, opts) {
  opts = opts || {};
  var book = el('journal');
  if (!book) return false;
  unstow();
  /* BK1: the gate. openByDate refuses before it fetches; this is the
     second door, for openFromSource and any later caller. */
  if (opts.land) land();
  else if (!mapView()) return false;
  raiseJournal();
  Journal.post = post; Journal.mode = 'essay';
  lastEssay = post;
  var inner0 = el('journal-inner');
  if (inner0) inner0.setAttribute('data-mode', 'essay');
  var no = el('journal-no');
  if (no) { no.textContent = post.numeral || ''; no.setAttribute('href', post.url || '#'); }
  if (el('journal-running-title')) el('journal-running-title').textContent = post.mapTitle || post.title || '';
  if (el('journal-running-date')) el('journal-running-date').textContent = post.readable || post.gridref || '';
  buildFlow(post, bodyHTML);
  measureJournal();
  turnTo(opts.page ? Math.ceil(opts.page / Journal.perView) - 1 : 0, { noHistory: true, instant: true });

  /* THE MAP DOES NOT MOVE UNLESS YOU ASKED IT TO (v14). Opening a mark on
     the plate is a click on the ground where the essay already is, and
     moving the ground under a hand that has just put itself down on it is
     the sheet arguing with the reader. The flight is kept only for a deep
     link, which arrives with no view at all (and the terminal's `open`);
     a line clicked in the contents no longer flies (JF1). */
  var c = (root.Room && Room.cellOf) ? Room.cellOf(post.date) : null;
  if (opts.fly && c && Room.centreOn) {
    var target = Room.fitWidth() * (isPortrait() ? 0.6 : 0.42);
    var free = isPortrait() ? 1 : 0.26;
    var shift = isPortrait() ? 0 : (0.5 - free / 2) * target;
    Room.centreOn(c[0] + shift, c[1], target);
  }
  /* N2: an open essay used to drive the day's pin into the plate as
     well, so a thread stood from the card to the station. There is no
     pin and no thread; the row in the contents is the mark of what is
     open, and it is marked here. */
  markBookRow(post.date);
  if (!opts.noHistory) {
    var url = withView(post.url + (opts.page > 1 ? '?p=' + opts.page : ''));
    if (opts.replace) history.replaceState({ sv: post.url }, '', url);
    else history.pushState({ sv: post.url }, '', url);
  }
  if (opts.focus !== false && el('journal-body')) el('journal-body').focus({ preventScroll: true });
  return true;
}

async function openByDate(date, opts) {
  var post = postByDate(date);
  if (!post) return false;
  opts = opts || {};
  /* BK1: refused outside the map view — and refused BEFORE the fetch, so
     a call from the room costs nothing and changes nothing. */
  if (!mapView() && !opts.land) return false;
  var body;
  if (essayCache.has(post.url)) body = essayCache.get(post.url);
  else {
    try {
      var res = await fetch(post.url, { credentials: 'same-origin' });
      var html = await res.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var src = doc.querySelector('#essay-source .essay-body');
      body = src ? src.innerHTML : '<p>' + RoomCopy.t('journal.unread') + '</p>';
    } catch (e) {
      body = '<p>' + RoomCopy.t('journal.unread') + ' <a href="' + post.url + '">' + RoomCopy.t('journal.open_direct') + '</a>.</p>';
    }
    essayCache.set(post.url, body);
  }
  return showJournal(post, body, opts);
}

function openFromSource(src, opts) {
  var post = postByDate(src.getAttribute('data-essay-date'));
  var bodyEl = src.querySelector('.essay-body');
  var body = bodyEl ? bodyEl.innerHTML : '';
  if (!post) {
    post = {
      no: parseInt(src.getAttribute('data-essay-no'), 10) || 0,
      numeral: src.getAttribute('data-essay-numeral'),
      date: src.getAttribute('data-essay-date'),
      readable: src.getAttribute('data-essay-readable'),
      gridref: src.getAttribute('data-essay-gridref'),
      title: src.getAttribute('data-essay-title'),
      url: src.getAttribute('data-essay-url')
    };
  }
  essayCache.set(post.url, body);
  return showJournal(post, body, opts);
}

function closeJournal(opts) {
  opts = opts || {};
  var book = el('journal');
  if (!book || book.getAttribute('data-open') !== 'true') return;
  /* PO1: upright the Journal is the page itself. Shutting an essay is
     going back to the contents; the contents do not shut. */
  if (upright() && !opts.really) {
    if (Journal.mode === 'essay') showContents({ noHistory: opts.noHistory, focus: false });
    return;
  }
  /* RS1 (2026-10-02): and the leaf it was open at. Tommy: "If you click the
     journal, does it reopen on the home page or open where you left off? If
     it's resumable, that could be quite good." A leaf number, not a spread,
     so it holds when the phone turns between one leaf and two. */
  Journal.last = { mode: Journal.mode, date: Journal.post ? Journal.post.date : null,
                   page: (Journal.spread || 0) * (Journal.perView || 1) + 1 };
  endTurn('journal');
  book.setAttribute('data-open', 'false');
  var tab = el('journal-tab');
  if (tab) tab.setAttribute('aria-expanded', 'false');
  Journal.post = null; Journal.mode = null;
  markBookRow(lastEssay ? lastEssay.date : null);
  if (!opts.noHistory) history.pushState({ sv: null }, '', withView('/'));
  /* SHUTTING A BOOK IS NOT A GESTURE ON THE MAP — it used to lay the
     whole sheet back out, which is why the zoom appeared to change by
     itself — and it moves nothing else either: the sheet is where the
     reader left it. */
}

/* RS1, and PO1's way in: the Journal where it was left, or its contents */
function resumeJournal() {
  var was = Journal.last;
  if (was && was.mode === 'essay' && was.date) return openByDate(was.date, { fly: false, page: was.page, focus: false });
  return showContents({ page: was && was.mode === 'contents' ? was.page : 0, noHistory: true, focus: false });
}
function toggleJournal() {
  var book = el('journal');
  if (!book) return false;
  if (book.getAttribute('data-open') === 'true') { closeJournal(); return true; }
  if (!mapView()) return false;                       /* BK1 */
  var was = Journal.last;
  if (was && was.mode === 'essay' && was.date) return openByDate(was.date, { fly: false, page: was.page });
  return showContents(was && was.mode === 'contents' ? { page: was.page } : undefined);
}

function wireJournal() {
  var book = el('journal');
  if (!book) return;
  var tab = el('journal-tab');
  if (tab) tab.addEventListener('click', function () {
    toggleJournal();   /* RS1: the cover reopens where the reader left off */
  });
  var cl = el('journal-contents');
  if (cl) cl.addEventListener('click', function (e) { e.preventDefault(); showContents(); });
  [['journal-next', 1], ['journal-prev', -1],
   ['journal-margin-next', 1], ['journal-margin-prev', -1]].forEach(function (pair) {
    var n = el(pair[0]);
    if (n) n.addEventListener('click', function () { turnTo(Journal.spread + pair[1]); });
  });
  /* the numeral in the running head is the way back to the ground */
  var no = el('journal-no');
  if (no) no.addEventListener('click', function (e) {
    e.preventDefault();
    if (!Journal.post || !root.Room || !Room.cellOf) return;
    var c = Room.cellOf(Journal.post.date);
    if (c) Room.centreOn(c[0], c[1], Room.fitWidth() * 0.30);
  });
  document.addEventListener('pointerdown', function (e) {
    if (book.getAttribute('data-open') !== 'true') return;
    if (isStowed(book)) return;              /* ST1 */
    if (!e.target.closest) return;
    if (e.target.closest('#journal')) {
      /* R72: a hand on the journal's own board, off the leaves, shuts it —
         the cover being closed; see the field book's for the notch it
         replaces */
      if (e.target.closest('#journal-body') && !e.target.closest('.journal-inner, button, a')) closeJournal();
      return;
    }
    /* a hand put down on the card's own control is not a hand put down
       off the book: the book stays out and shows the other essay */
    if (e.target.closest('.dc-essay, .journal-contents .jc-entry')) return;
    closeJournal();
  }, true);
  /* C: taken here and not again in wireKeys (see the field book's) */
  book.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowRight') { turnTo(Journal.spread + 1); e.preventDefault(); e.stopPropagation(); }
    else if (e.key === 'ArrowLeft') { turnTo(Journal.spread - 1); e.preventDefault(); e.stopPropagation(); }
    else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') e.preventDefault();
  });
  window.addEventListener('popstate', function () {
    var post = null, path = location.pathname;
    for (var i = 0; i < POSTS.length; i++) if (POSTS[i].url === path) post = POSTS[i];
    /* JF1: back and forward do not fly the map either; the address carries the view */
    if (post) openByDate(post.date, { noHistory: true, page: pageParam(), fly: false, land: true });
    else closeJournal({ noHistory: true });
  });
  function repage(force) {
    if (book.getAttribute('data-open') !== 'true') return;
    clearTimeout(Journal.rt);
    Journal.rt = setTimeout(function () {
      if (book.getAttribute('data-open') !== 'true') return;
      if (PHONE_TR && force !== true && Journal.mkey === journalKey()) return;
      var was = Journal.spread * Journal.perView + 1;
      if (Journal.mode === 'contents') buildContents();
      measureJournal();
      turnTo(Math.ceil(was / Journal.perView) - 1, { noHistory: true, instant: true });
      if (Journal.mode === 'contents') { wireContentsRows(); markBookRow(lastEssay ? lastEssay.date : null); }
    }, 220);
  }
  window.addEventListener('resize', repage);
  /* PJ1: ON THE PHONE THE LEAF IS COUNTED AGAIN WHEN IT SETTLES. Chrome on
     an iPhone shows and hides its bar as the page is touched, and the leaf
     is sized in dvh, so the leaf changes height without always being a
     window resize; the visual viewport says so, and the leaf's own text
     block says so for certain. The fonts landing re-set the lines too.
     Each is the same debounced count, so a bar sliding is one count when
     it stops. Phone only: the desk's spread is as it was. */
  if (/\bphone\b/.test(document.documentElement.className)) {
    if (window.visualViewport) window.visualViewport.addEventListener('resize', repage);
    var clip = el('journal-clip'), seen = null;
    if (clip && window.ResizeObserver) new ResizeObserver(function () {
      var k = clip.clientWidth + 'x' + clip.clientHeight;
      if (k !== seen) { seen = k; repage(); }
    }).observe(clip);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { repage(true); });
  }
  window.addEventListener('resize', function () {
    var key = el('key');
    if (!key || key.getAttribute('data-open') !== 'true') return;
    clearTimeout(Book.rt);
    Book.rt = setTimeout(function () {
      if (PHONE_TR && Book.mkey === bookKey()) return;
      var page = Book.spread * Book.perView;
      repageBook(page);
    }, 220);
  });
}

/* ---- the keys the books take --------------------------------------- */
function wireKeys() {
  document.addEventListener('keydown', function (e) {
    if (e.target && e.target.matches && e.target.matches('input,textarea')) return;
    /* R60: not while the reader is turned to the machine. The books are
       things in the room, but `b`, `j` and the arrows are the reader's
       hand, and the hand is on the laptop. (engine.js's capture gate
       stops these before they arrive; this is the belt to that brace,
       for a page whose engine has not booted.) */
    if (root.Room && Room.lapUp && Room.lapUp()) return;
    if (e.key === 'b' || e.key === 'B') {
      var k = el('key');
      if (k) setKey(k.getAttribute('data-open') !== 'true');
    } else if (e.key === 'j' || e.key === 'J') {
      toggleJournal();
    } else if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
      var b = openBook();
      if (!b) return;
      e.preventDefault();
      var d = e.key === 'ArrowRight' ? 1 : -1;
      if (b === 'journal') turnTo(Journal.spread + d); else showSpread(Book.spread + d);
    }
  });
}

/* ================================================================
   THE FACE
   ================================================================ */
/* R70: called from openWindow when a record LANDS (never at boot — see
   the note there). The leaves are cloned into the spread, so both the
   source and whatever is on show are re-struck. */
B.rescale = function (scale) {
  paintTintScale(scale);
  paintLevels(scale || null);
  if (Book.leaves.length) repageBook(Book.spread * Book.perView);
};

B.init = function (opts) {
  POSTS = (opts && opts.posts) || [];
  wireKey();
  wireJournal();
  wireKeys();
  /* a deep link to an essay: the page IS the essay, so its body is in
     the document and nothing is fetched */
  var essay = el('essay-source');
  /* BK1: a deep link LANDS — it opens and brings the view back to the
     paper. It is never opened into an unfurled room or a folded sheet. */
  if (essay && essay.getAttribute('data-essay-date')) {
    openFromSource(essay, { replace: true, page: pageParam(), fly: true, land: true });
  } else if (document.querySelector('[data-open-contents]') || Q.get('contents') === '1') {
    showContents({ noHistory: true, focus: false, land: true });
  }
  var j = Q.get('journal');
  if (j === '1') showContents({ noHistory: true, focus: false, land: true });
  else if (j && /^\d{4}-\d{2}-\d{2}$/.test(j)) openByDate(j, { noHistory: true, fly: false, land: true });
  /* JL1: upright on a phone, the Journal in the frame the map lands in */
  if (root.RoomPhone && RoomPhone.booksIn) RoomPhone.booksIn();
};
/* Esc peels ONE thing: the engine asks here first, and only lays the
   sheet flat if neither book was out and no day was pinned. */
B.closeOne = function () {
  var b = openBook();
  if (!b) return false;
  if (b === 'journal') closeJournal(); else setKey(false);
  return true;
};
/* PO1: phone.js, on the turn upright with no book out */
B.resumeJournal = resumeJournal;
/* BK1: a refusal is FALSE, and it is synchronous. `openByDate` is async
   because it may have to fetch the essay; a caller that is told "not
   here" must not be handed a promise of a refusal, so the gate is on this
   side of the door as well as behind it. */
B.openByDate = function (date, opts) {
  if (!mapView() && !(opts && opts.land)) return false;
  return openByDate(date, opts);
};
B.showContents = showContents;
B.open = openBook;
/* BK1: the one test, published for desk-books.js (the covers' hit target
   and the hover lift ask it) and for the harness. */
B.mapView = mapView;
B.landing = function () { return landing; };
B.state = function () {
  return { open: openBook(), mode: Journal.mode, page: Journal.spread * Journal.perView + 1,
           pages: Journal.pages, post: Journal.post ? Journal.post.date : null,
           cached: essayCache.size, keyPage: Book.spread * Book.perView + 1,
           keyPages: Book.leaves.length, leavesPerView: openBook() === 'key' ? Book.perView : Journal.perView };
};
})(window);
